export default __webpack_public_path__ + "static/media/Slide18.4717bb42.PNG";